import { ActionIcon, Flex } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { FormField } from '@dealstack/frontend/shared/components/Documents/FormFields/types';
import {
	DOCUMENT_LIBRARY_ELEMENT_ID,
	makeComplexDataTestId,
} from '@dealstack/shared/tests/testElementIds';

interface Props {
	onCancel: () => void;
	onSave: (field: FormField) => Promise<void>;
	field: FormField;
}

export const InlineFieldSubmission = ({ onCancel, onSave, field }: Props) => {
	return (
		<Flex gap="0.5rem" align="center">
			<ActionIcon
				data-testid={makeComplexDataTestId(
					DOCUMENT_LIBRARY_ELEMENT_ID.FIELD_CANCEL_BUTTON,
					field.fieldKey as string
				)}
				variant="filled"
				color="gray.04"
				size="lg"
				onClick={() => onCancel()}
			>
				<Icon variant="close" size="lg" color="black" />
			</ActionIcon>
			<ActionIcon
				data-testid={makeComplexDataTestId(
					DOCUMENT_LIBRARY_ELEMENT_ID.FIELD_SAVE_BUTTON,
					field.fieldKey as string
				)}
				variant="filled"
				color="blue"
				size="lg"
				onClick={async () => await onSave(field)}
			>
				<Icon variant="checkmark" size="lg" />
			</ActionIcon>
		</Flex>
	);
};
